var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.stream
    ? _c("div", { staticClass: "stream-start-alert" }, [
        _c("div", { staticClass: "container" }, [
          _c("div", { staticClass: "stream-start-alert__body" }, [
            _vm.stream.status == "prepare"
              ? _c("div", { staticClass: "stream-start-alert__text" }, [
                  _vm._v(
                    "Старт нового потока " +
                      _vm._s(
                        _vm._f("moment")(_vm.stream.date_start, "D MMMM")
                      ) +
                      "! Следите за нами!"
                  ),
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.stream.status == "process"
              ? _c("div", { staticClass: "stream-start-alert__text" }, [
                  _vm._v(
                    "Старт нового потока уже завтра! Успейте начать с нами!"
                  ),
                ])
              : _vm._e(),
            _vm._v(" "),
            _c("div", { staticClass: "stream-start-alert__icons" }, [
              _c(
                "a",
                {
                  staticClass:
                    "stream-start-alert__social-icon stream-start-alert__social-icon--vk",
                  attrs: {
                    href: "https://vk.com/perezagryzka_team",
                    target: "_blank",
                  },
                },
                [
                  _c("img", {
                    attrs: {
                      src: _vm.staticBase + "images/vk-logo.svg",
                      alt: "Вконтакте",
                    },
                  }),
                ]
              ),
              _vm._v(" "),
              _c(
                "a",
                {
                  staticClass:
                    "stream-start-alert__social-icon stream-start-alert__social-icon--youtube",
                  attrs: {
                    href: "https://www.youtube.com/@PEREZAGRYZKA",
                    target: "_blank",
                  },
                },
                [
                  _c("img", {
                    attrs: {
                      src: _vm.staticBase + "images/youtube-logo.svg",
                      alt: "YouTube",
                    },
                  }),
                ]
              ),
            ]),
          ]),
        ]),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }